/* tslint:disable */
/* eslint-disable */
export enum WorkTicketPerformanceGranularityEnum {
  Week = 'WEEK',
  Month = 'MONTH'
}
